module.exports = __webpack_public_path__ + "cfbf85f9713f1dc4e10c281e15eb6cb4.svg";